import React from 'react';
import Team from '@/components/about/Team/Team';
import Mission from '@/components/about/Mission/Mission';
import Values from '@/components/about/Values/Values';
import Timeline from '@/components/about/Timeline/Timeline';
import CaseStudy from '@/components/about/CaseStudy/CaseStudy';

const About: React.FC = () => {
  return (
    <div>
      <section className="py-20 min-h-[40vh] flex items-center">
        <div className="container-custom text-center">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 gradient-text">
            O nas
          </h1>
          <p className="text-xl text-secondary max-w-2xl mx-auto">
            Poznaj zespół ludzi, którzy tworzą przyszłość internetu
          </p>
        </div>
      </section>
      <Team />
      <Mission />
      <Values />
      <Timeline />
      <CaseStudy />
    </div>
  );
};

export default About;
